
export const hasPermission = (aliasID, permissionKey, allowedActions) => {
  // admin => true
  if (aliasID?.includes('admin')) {
    return true
  }
  
 return true
};

export const PERMISSION_LIST = {
  deviceManagement: [
    { id: 1, action: 'view' },
    { id: 2, action: 'edit' },
  ],
  dataEntry: [
    { id: 3, action: 'view' },
    { id: 4, action: 'edit' },
  ],
  history: [{ id: 5, action: 'view' }],
  shiftManagement: [
    { id: 6, action: 'view' },
    { id: 7, action: 'edit' },
  ],
  scheduleSetup: [
    { id: 8, action: 'view' },
    { id: 9, action: 'edit' },
  ],
  holidaySetup: [
    { id: 10, action: 'view' },
    { id: 11, action: 'edit' },
  ],
  overtimeManagement: [
    { id: 12, action: 'view' },
    { id: 13, action: 'edit' },
    { id: 14, action: 'approve' },
  ],
  regimeManagement: [
    { id: 15, action: 'view' },
    { id: 16, action: 'edit' },
    { id: 17, action: 'approve' },
  ],
  leaveManagement: [
    { id: 18, action: 'view' },
    { id: 19, action: 'edit' },
    { id: 20, action: 'approve' },
  ],
  otherReasons: [
    { id: 21, action: 'view' },
    { id: 22, action: 'edit' },
    { id: 23, action: 'approve' },
  ],
  attendanceReport: [
    { id: 35, action: 'view' },
    { id: 24, action: 'Chấm công' },
    { id: 36, sub: 'Báo cáo cơm ca', action: 'view' },
    { id: 37, sub: 'Báo cáo cơm ca', action: 'exel' },
    { id: 38, sub: 'Báo cáo cơm ca', action: 'pdf' },
    { id: 39, sub: 'Báo cáo chấm công chi tiết', action: 'view' },
    { id: 40, sub: 'Báo cáo chấm công chi tiết', action: 'exel' },
    { id: 41, sub: 'Báo cáo chấm công chi tiết', action: 'pdf' },
    { id: 42, sub: 'Báo cáo lịch sử vào ra', action: 'view' },
    { id: 43, sub: 'Báo cáo lịch sử vào ra', action: 'exel' },
    { id: 44, sub: 'Báo cáo lịch sử vào ra', action: 'pdf' },
    { id: 45, sub: 'Bảng chấm công', action: 'view' },
    { id: 46, sub: 'Bảng chấm công', action: 'exel' },
    { id: 47, sub: 'Bảng chấm công', action: 'pdf' },
    { id: 48, sub: 'Báo cáo nhân sự đi trễ', action: 'view' },
    { id: 49, sub: 'Báo cáo nhân sự đi trễ', action: 'exel' },
    { id: 50, sub: 'Báo cáo nhân sự đi trễ', action: 'pdf' },
    { id: 51, sub: 'Báo cáo nhân sự về sớm', action: 'view' },
    { id: 52, sub: 'Báo cáo nhân sự về sớm', action: 'exel' },
    { id: 53, sub: 'Báo cáo nhân sự về sớm', action: 'pdf' },
    { id: 54, sub: 'Báo cáo ca làm việc', action: 'view' },
    { id: 55, sub: 'Báo cáo ca làm việc', action: 'exel' },
    { id: 56, sub: 'Báo cáo ca làm việc', action: 'pdf' },
    { id: 57, sub: 'Bảng giải trình chấm công', action: 'view' },
    { id: 58, sub: 'Bảng giải trình chấm công', action: 'exel' },
    { id: 59, sub: 'Bảng giải trình chấm công', action: 'pdf' },
    { id: 60, sub: 'Bảng tổng hợp công tăng ca', action: 'view' },
    { id: 61, sub: 'Bảng tổng hợp công tăng ca', action: 'exel' },
    { id: 62, sub: 'Bảng tổng hợp công tăng ca', action: 'pdf' },
  ],
  departmentManagement: [
    { id: 28, action: 'view' },
    { id: 29, action: 'edit' },
  ],
  positionManagement: [
    { id: 30, action: 'view' },
    { id: 31, action: 'edit' },
  ],
  employeeManagement: [{ id: 32, action: 'use' }],
  deviceSetup: [{ id: 33, action: 'use' }],
  fingerprintManagement: [{ id: 34, action: 'use' }],
};

export const MODULE_LABELS = {
  deviceManagement: 'Quản lý thiết bị',
  dataEntry: 'Nhập dữ liệu chấm công',
  history: 'Lịch sử ra vào',
  shiftManagement: 'Quản lý ca làm việc',
  scheduleSetup: 'Thiết lập lịch làm việc',
  holidaySetup: 'Thiết lập ngày nghỉ',
  overtimeManagement: 'Quản lý tăng ca',
  regimeManagement: 'Quản lý chế độ',
  leaveManagement: 'Quản lý CT, HH, TH...',
  otherReasons: 'Các lý do khác',
  timekeeping: 'Chấm công',
  preview: 'Xem trước',
  exportExcel: 'Xuất Excel',
  exportPdf: 'Xuất PDF',
  departmentManagement: 'Quản lý phòng ban',
  positionManagement: 'Quản lý chức vụ',
  employeeManagement: 'Quản lý nhân viên',
  deviceSetup: 'Thiết lập máy chấm công',
  fingerprintManagement: 'Quản lý vân tay',
  attendanceReport: 'Báo cáo chấm công'
}

export const ACTION_LABELS = {
  view: 'Xem',
  edit: 'Chỉnh sửa',
  approve: 'Duyệt',
  export: 'Xuất',
  use: 'Sử dụng',
  filter: 'Lọc',
  upload: 'Tải lên',
  exel: 'Xuất exel',
  pdf: 'Xuất PDF',
}
